import { START_UI_LOADER, STOP_UI_LOADER } from "../actions/actionTypes";

const initialState = {
  isLoading: false
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_UI_LOADER:
      return {
        ...state,
        isLoading: true
      };
    case STOP_UI_LOADER:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};

export default uiReducer;
